import React from 'react';
import { hot } from 'react-hot-loader';
import Icons from '../Icons/Icons';
import { purifier } from '../../../utils/dom';
import s from './Radio.scss';

const Radio = ({ id, options, selected, inputChange, hidden = false, variation = false }) => {
	const inputChangeHandler = (e) => {
		e.preventDefault();
		const value = e.target.value;
		inputChange(value);
	};

	return (
		options.map((option) => (
			<label key={option.key} htmlFor={option.key} className={[s.radio, (option.key === selected ? s.radio__selected : null), (variation ? s[`radio__${variation}`] : null), (hidden ? s.radio__hidden : null), (option.disabled ? s.radio__disabled : null)].join(' ')}>
				<input className={s.radio_input} id={option.key} type="radio" name={id} value={option.key} disabled={option.disabled} checked={option.key === selected} onChange={inputChangeHandler} />
				<span />{ !option.info && <span className={s.radio_content} dangerouslySetInnerHTML={{ __html: purifier(option.value, { ALLOWED_TAGS: ['b', 'strong'] }) }} /> }
				{ option.info && <p className={s.radio_info}>{option.icon && <Icons className={s.radio_info_icon} uri={option.icon} />}<div dangerouslySetInnerHTML={{ __html: purifier(option.info, { ALLOWED_TAGS: ['b', 'strong'] }) }} /></p> }
			</label>
		))
	);
};

export default hot(module)(Radio);
